exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.skeleton[data-v-4bb9978a] {\n  background-image: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0),\n    rgba(255, 255, 255, 0.04) 10%,\n    rgba(255, 255, 255, 0) 30%\n  );\n\n  background-repeat: repeat-y;\n  background-position: 1200px 1200px;\n\n  -webkit-animation: shine-data-v-4bb9978a 1s infinite;\n\n          animation: shine-data-v-4bb9978a 1s infinite;\n}\n@-webkit-keyframes shine-data-v-4bb9978a {\nto {\n    background-position: 100% 0;\n}\n}\n@keyframes shine-data-v-4bb9978a {\nto {\n    background-position: 100% 0;\n}\n}\n.cus-size[data-v-4bb9978a] {\n  width: 230px;\n  height: 25px;\n}\n", ""]);

// exports
